import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { RoleGuard } from '@components/Guards';

import { RoleName } from '@constants/role_name';

import AdminManagement from '@views/Admin/Management';

const messages = defineMessages({
  title: {
    id: 'admin.configurations.title',
    defaultMessage: 'Configurations',
  },
});

function AdminConfigurationsPage() {
  const { formatMessage } = useIntl();

  return (
    <RoleGuard roles={[RoleName.Admin]}>
      <AdminManagement.Layout title={formatMessage(messages.title)}>
        <AdminManagement.Configurations.Main />
      </AdminManagement.Layout>
    </RoleGuard>
  );
}

export default AdminConfigurationsPage;
